export default __webpack_public_path__ + "static/media/barrel-seagull.a82bbd34.jpeg";